module.exports = __webpack_public_path__ + "img/zhuanghuodian.87b92926.png";